import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotFoundComponent } from './not-found.component';
import { IRouteConfigsOpts } from './../../../routing/route.config';
const routes: IRouteConfigsOpts[] = [
  {
    path: '',
    authenticationRequired: false,
    rolePermissions: ['all'],
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotFoundRoutingModule {}
